import { ReactNode } from 'react';
import {
  Thead,
  Tbody,
  Tr as ChakraTr,
  Th as ChakraTh,
  Td as ChakraTd,
  TableContainer,
  TableCellProps,
  TableColumnHeaderProps,
} from '@chakra-ui/react';
import * as Styles from './Table.styles';

interface CustomTableProps<DataType> {
  data: DataType[];
  renderHeader: ReactNode;
  renderRow: (value: DataType, index: number) => ReactNode;
  customBorderColor?: string;
  renderEmptyState?: JSX.Element;
  customBorderRadius?: number;
  className?: string;
}

interface CustomTD extends TableCellProps {
  children?: ReactNode;
}

interface CustomTh extends TableColumnHeaderProps {
  children?: ReactNode;
}

const TableComponent = function <DataType>({
  data,
  renderHeader,
  renderRow,
  customBorderColor,
  customBorderRadius,
  renderEmptyState,
  className,
}: CustomTableProps<DataType>): JSX.Element {
  const filteredData = data.filter(Boolean);

  return (
    <TableContainer
      className={className}
      borderRadius={customBorderRadius || '12px'}
      boxShadow="none"
      border={customBorderColor ? `1px solid ${customBorderColor}` : '2px solid #F4F4F5'}
      overflow="hidden"
    >
      <Styles.CustomTable variant="simple">
        <Thead>{renderHeader}</Thead>
        <Tbody>
          {filteredData.length === 0 && renderEmptyState
            ? renderEmptyState
            : filteredData.map(renderRow)}
        </Tbody>
      </Styles.CustomTable>
    </TableContainer>
  );
};

export const Td = ({ children, ...props }: CustomTD): JSX.Element => {
  return (
    <ChakraTd
      color="#09090B"
      fontSize="14px"
      lineHeight="21px"
      fontWeight="400"
      padding="14px 20px"
      {...props}
    >
      {children}
    </ChakraTd>
  );
};

export const Th = ({ children, ...props }: CustomTh): JSX.Element => {
  return (
    <ChakraTh
      color="#71717A"
      fontSize="12px"
      lineHeight="16px"
      fontWeight="500"
      padding="14px 20px"
      textTransform="uppercase"
      letterSpacing="0.5px"
      {...props}
    >
      {children}
    </ChakraTh>
  );
};

export const Tr = ChakraTr;

export default TableComponent;
